<script>
  // eslint-disable-next-line no-unused-vars
  /* global portalApp */
  import { redirect } from "@roxi/routify"

  $redirect("/home")
</script>
